import type { GlobalState } from '../../reducers';

import { createSelector } from '@reduxjs/toolkit';

export const getGlobalState = createSelector(
  (state: GlobalState) => state,
  state => state
);
